export default "__VITE_ASSET__DblVE2Fe__"